export default __webpack_public_path__ + "static/media/GaugeImg4.891326f7.jpg";